import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import DomainsSlider from '../components/DomainsSlider';
import ServicesSection from '../components/ServicesSection';
import ClientsSection from '../components/ClientsSection';
import StatsSection from '../components/StatsSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="home">
      <Header />
      <HeroSection />
      <DomainsSlider />
      <ServicesSection />
      <ClientsSection />
      <StatsSection />
      <Footer />
    </div>
  );
};

export default Home;